<template>
  <div class="mainBackground">
    <template>
      <img
        style="width:100%"
        src="https://mdl.mfu.ac.th/mdl_material/banner/BANNER-02.jpg"
      />
      <CModal
        title="Modal title"
        :show.sync="modalShow"
        add-content-classes="bgmodalmdl"
        :closeOnBackdrop="false"
        centered
      >
        <template #header-wrapper>
          <div style="text-align:center;padding-top:20px">
            <h3 class="mt-4">Register from {{ courseCode }}</h3>
          </div>
        </template>
        <template #body-wrapper>
          <div class="modal-text-success">
            <div
              class="p-3 mt-1"
              style="margin-left:20px; margin-right:20px;margin-bottom:20px"
            >
              <div @keyup.enter="login">
                <input
                  v-model.trim="email"
                  placeholder="Student ID"
                  type="email"
                  class="underline"
                  style="margin-bottom: 1.2rem;width:100%"
                />
                <br />
                <input
                  v-model="password"
                  placeholder="Password"
                  type="password"
                  class="underline"
                  style="margin-bottom: 1.2rem;width:100%"
                />
                <Button :click="login" class="mt-4">SIGN IN</Button>
              </div>
            </div>
          </div>
        </template>
        <template #footer-wrapper>
          <div></div>
        </template>
      </CModal>
    </template>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Button from "../components/signInCss/Button.vue";
export default {
  components: { Button },
  data() {
    return {
      courseCode: this.$route.params.courseCode,
      username: null,
      passoword: null,
      modalShow: true,
    };
  },
  computed: {
    ...mapGetters({
      userCourses: "auth/userCourses",
    }),
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    onChangeText(text, type) {
      if (type) {
        this.username = text;
      }
    },
  },
};
</script>

<style scoped>
.mainBackground {
  overflow: hidden;
  padding-top: 56px;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.bgmodalmdl {
  border-radius: 30px;
}
.underline {
  border: 0;
  outline: 0;
  background: transparent;
  border-bottom: 1px solid #cccccc;
  font-size: 14px;
}

.formBackground {
  background-color: white;
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
}

/* ------------------------------------------------------------ css Scrollbar ------------------------------------------------------------ */
@media only screen and (min-width: 374px) {
  .mainBackground {
    min-height: 70vh;
  }
}
@media only screen and (min-width: 767px) {
  .mainBackground {
    min-height: 75vh;
  }
}
@media only screen and (min-width: 1023px) {
  .mainBackground {
    min-height: 87vh;
  }
}
</style>
